<template>
  <div class="dashboard-container">
    <!-- 오른쪽 메인 콘텐츠 영역 - 배경 효과 적용 -->
    <div class="main-content-wrapper">
      <AnimatedBackground backgroundColor="white" />
      
      <!-- Header Section -->
      <div class="header-section">
        <div class="flex items-center justify-between">
          <div>
            <h1 class="text-2xl font-semibold text-foreground">
              안녕하세요, {{ displayName }}님! 👋
            </h1>
            <p class="text-muted-foreground mt-1">
              오늘도 즐거운 강의 되세요
            </p>
          </div>
        </div>
      </div>

      <!-- Lecture Statistics -->
      <div class="button-container">
        <EnergyParameters
          :data-mode="'real-time'"
          :selected-device="'all'"
          @create-lecture="showCreateMeetingModal = true"
          @join-lecture="showJoinMeetingModal = true"
        />
      </div>
    </div>

    <!-- Charts Section -->
    <!-- 추후 사용을 위해 주석 처리 -->
    <!--
    <div class="charts-grid">
      <ScheduleCalendar />
      <ConsumptionChart
        :selected-day="'today'"
        :selected-device="'all'"
      />
    </div>
    -->

    <!-- Modals -->
    <CreateMeetingModal v-if="showCreateMeetingModal" @close="showCreateMeetingModal = false" />
    <JoinMeetingModal v-if="showJoinMeetingModal" @close="showJoinMeetingModal = false" />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, computed, ref, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { useAuth } from '@/composables/useAuth'

// Dashboard components
import EnergyParameters from '@/components/EnergyParameters.vue'
import AnimatedBackground from '@/components/AnimatedBackground.vue'
//시간표 및 차트 주석처리
// import ScheduleCalendar from '@/components/ScheduleCalendar.vue'
// import ConsumptionChart from '@/components/ConsumptionChart.vue'

// Modal components
import CreateMeetingModal from '@/components/modals/CreateMeetingModal.vue'
import JoinMeetingModal from '@/components/modals/JoinMeetingModal.vue'

const router = useRouter()
const { isAuthenticated, userName, fetchUserName } = useAuth()

// Modal states
const showCreateMeetingModal = ref(false)
const showJoinMeetingModal = ref(false)

// 사용자 이름 표시용 computed
const displayName = computed(() => {
  return userName.value || '사용자'
})

// 사이드바 상태 감지 및 반응
const checkSidebarState = () => {
  nextTick(() => {
    // 사이드바 상태 확인 후 강제로 리사이즈 이벤트 트리거
    // 이렇게 하면 App.vue의 margin이 재계산되어 배경이 올바른 위치에 표시됨
    const sidebarWrapper = document.querySelector('.sidebar-wrapper')
    if (sidebarWrapper) {
      // 강제로 리사이즈 이벤트 트리거하여 App.vue의 margin 재계산 유도
      window.dispatchEvent(new Event('resize'))
    }
  })
}

// 사이드바 상태 변경 감지
let observer = null

onMounted(async () => {
  if (!isAuthenticated.value) {
    router.push('/login')
    return
  }
  
  // 사용자 이름이 없으면 가져오기
  if (!userName.value) {
    await fetchUserName()
  }
  
  // 초기 사이드바 상태 확인
  checkSidebarState()
  
  // 사이드바 상태 변경 감지를 위한 MutationObserver
  const sidebarWrapper = document.querySelector('.sidebar-wrapper')
  if (sidebarWrapper) {
    observer = new MutationObserver(() => {
      checkSidebarState()
    })
    
    observer.observe(sidebarWrapper, {
      attributes: true,
      attributeFilter: ['class']
    })
  }
  
  // 추가로 짧은 지연 후 다시 확인 (렌더링 완료 보장)
  setTimeout(() => {
    checkSidebarState()
  }, 100)
})

onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }
})
</script>

<style scoped>
.dashboard-container {
  min-height: 100vh;
  position: relative;
}

/* 오른쪽 메인 콘텐츠 영역 - App.vue의 main-content margin을 활용 */
.main-content-wrapper {
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
}

.header-section {
  padding: 1.5rem;
  position: relative;
  z-index: 1;
}

/* 강의 생성/참가 버튼 중앙 정렬 */
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 1.5rem;
  min-height: 60vh;
  position: relative;
  z-index: 1;
}

.button-container .energy-parameters {
  max-width: 900px;
  width: 100%;
}

@media (min-width: 768px) {
  .button-container .energy-parameters {
    max-width: 1000px;
  }
}

@media (min-width: 1024px) {
  .button-container .energy-parameters {
    max-width: 1200px;
  }
}

/* 추후 사용을 위해 주석 처리 */
/*
.charts-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  padding: 0 1.5rem 1.5rem;
}

@media (min-width: 1024px) {
  .charts-grid {
    grid-template-columns: 1fr 1fr;
  }
}
*/
</style>